import { render, staticRenderFns } from "./ChiefWhip.vue?vue&type=template&id=e8df5be4&scoped=true&"
import script from "./ChiefWhip.vue?vue&type=script&lang=js&"
export * from "./ChiefWhip.vue?vue&type=script&lang=js&"
import style0 from "./ChiefWhip.vue?vue&type=style&index=0&id=e8df5be4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8df5be4",
  null
  
)

export default component.exports